// ─── Break Time wizard step definitions ───────────────────────────────────

export const BREAKTIME_STEPS = [
  {
    key: 'name',
    label: 'Break time name:',
    hint: 'A unique label for this break (e.g. "Lunch Break", "Prayer Break").',
  },
  {
    key: 'calculation_type',
    label: 'Calculation type:',
    hint: 'Auto Deduct = system deducts automatically. Require Punch = employee must clock out/in.',
    options: [
      { label: 'Auto Deduct', value: 'A' },
      { label: 'Require Punch', value: 'P' },
    ],
  },
  {
    key: 'start_time',
    label: 'Break start time (HH:MM):',
    hint: 'When the break period begins (e.g. 13:00).',
  },
  {
    key: 'end_time',
    label: 'Break end time (HH:MM):',
    hint: 'When the break period ends (e.g. 14:00).',
  },
  {
    key: 'end_cross_day',
    label: 'End cross day (0, 1, 2, or 3):',
    hint: '0 = break ends same day. Use 1 if the break crosses midnight.',
    options: [
      { label: '0 — Same day', value: '0' },
      { label: '1 — Next day', value: '1' },
    ],
  },
  {
    key: 'duration',
    label: 'Duration in minutes:',
    hint: 'Auto-calculated from start and end time.',
    skipIf: (data) => !!(data.start_time && data.end_time),
  },
  {
    key: 'with_salary',
    label: 'Count with salary (paid break)?',
    hint: 'Yes = break time is paid. No = break time is unpaid.',
    options: [
      { label: 'Yes — Paid break', value: 'Y' },
      { label: 'No — Unpaid break', value: 'N' },
    ],
  },
]
